import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { InlineWidget } from "react-calendly";


const ThankYou = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (<Box>
            <Box
                sx={{
                    width: '100%',
                    height: 'fit-content',
                    minHeight: '62svh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: 'linear-gradient(360deg, #F95F43 0%, #F1417A 100%)',
                    marginTop: '75px',
                    overflow: 'hidden',
                    textAlign: 'center',
                }}
            >
                <Container>
                    <Typography variant={'h4'} component={'h1'} mt={5}>
                        {t('thankyou.title_1')}<br/>{t('thankyou.title_2')}
                    </Typography>
                    <Typography variant={'h5'} component={"h2"} my={4}>
                        {t('thankyou.subtitle')}
                    </Typography>
                    <Box my={4}>
                        <InlineWidget url={"https://calendly.com/giacomo-plesh/match-call-con-giacomo"} styles={{ height: '700px' }} />
                    </Box>
                </Container>
            </Box>
            <Footer/>
        </Box>
    )
}

export default ThankYou;
